export const AppProfilePageType = {
  invalid: -1,
  unset: 0,
  on: 1,
  off: 2,
};
